var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import CheckIcon from "@mui/icons-material/Check";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Tooltip } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
var COPIED_MS = 2000;
/**
    A copy icon with a short menu of things to copy (plain MUI menu, like the booking dialog's ⋮). Picking one
    closes the menu and swaps the icon for a green check that pops in; after two seconds the copy icon comes back
    without animation.
*/
var CopyMenuButton = function (_a) {
    var entries = _a.entries;
    var t = useTranslation().t;
    var _b = useState(null), menuAnchor = _b[0], setMenuAnchor = _b[1];
    var _c = useState(false), copied = _c[0], setCopied = _c[1];
    var resetTimer = useRef();
    useEffect(function () { return function () { return clearTimeout(resetTimer.current); }; }, []);
    var copy = function (entry) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setMenuAnchor(null);
                    return [4 /*yield*/, navigator.clipboard.writeText(entry.text())];
                case 1:
                    _a.sent();
                    clearTimeout(resetTimer.current);
                    setCopied(true);
                    resetTimer.current = setTimeout(function () { return setCopied(false); }, COPIED_MS);
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(_Fragment, { children: [_jsx(Tooltip, __assign({ title: copied ? t('Copied') : t('Copy'), arrow: true }, { children: _jsx(IconButton, __assign({ "aria-label": t('Copy'), "aria-haspopup": 'menu', "aria-expanded": !!menuAnchor, onClick: function (event) { return setMenuAnchor(event.currentTarget); }, sx: { width: 36, height: 36, color: 'text.secondary' } }, { children: copied ? (_jsx(CheckIcon, { sx: {
                            fontSize: 20,
                            color: 'success.main',
                            animation: 'CopyMenuButton-pop 220ms ease-out',
                            '@keyframes CopyMenuButton-pop': {
                                from: { transform: 'scale(0.4)', opacity: 0 },
                                to: { transform: 'scale(1)', opacity: 1 }
                            }
                        } })) : (_jsx(ContentCopyIcon, { sx: { fontSize: 20 } })) })) })), _jsx(Menu, __assign({ anchorEl: menuAnchor, open: !!menuAnchor, onClose: function () { return setMenuAnchor(null); } }, { children: entries.map(function (entry) { return (_jsxs(MenuItem, __assign({ onClick: function () { return copy(entry); } }, { children: [_jsx(ListItemIcon, { children: _jsx(entry.Icon, { fontSize: 'small' }) }), _jsx(ListItemText, { children: entry.label })] }), entry.label)); }) }))] }));
};
export default CopyMenuButton;
